import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NomdistricencostosService } from "../nomservicios/nomdistricencostos.service";
import { MessageService, ConfirmationService } from 'primeng';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { NuevoComponentService } from 'src/app/servicios/nuevo-component.service';
import { CellEditorPrueba } from 'src/app/advantage/config/cell-edit-prueba';
import { SelectItem } from 'primeng/api/selectitem';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { NomDetDistricen } from "../nominterfaces/nomdetdistricen";
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import * as XLSX from 'xlsx';//CDPJ
@Component({
  selector: 'app-nomdistricencostos',
  templateUrl: './nomdistricencostos.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class NomdistricencostosComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef

  btnNuevo = false
  btnGuardar = true;
  btnBorrar = false;
  btnRegresar = true;
  botonPrimero = false;
  botonAnterior = false;
  botonSiguiente = false;
  botonUltimo = false;
  btnBuscar = false;
  fechasPeriodo: string;
  perCodigo = 0;
  detnomdistricenSelected: NomDetDistricen;
  displayDialogDistribucion: boolean;
  spin = false;
  cmbTIPROL = [];
  cmbDEP_CODIGO = '';

  index = 0
  indicador: any;
  permisos: SegMaePermiso;
  largo: string;
  defaultDetdistricen
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle
  selecttipodep: any;
  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  where: string;
  opcion: string;
  displayDialogBus: boolean;
  displayDialogBusquedaFast: boolean;
  datosJson: Array<{ CEDULA: string; CENCODIGO: string; DIAS: number }> = [];
  perdiascal;
  //reportes
  strNombreForma: string;
  auxreporte: number = 0;
  displayDialogReportes: boolean;
  displayAcciones: boolean;

  columnDefsDetdistricen = [
    {
      headerName: 'Código', field: 'EMP_CODIGO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'RUC/CED', field: 'EMP_RUCIDE', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'Empleado', field: 'EMP_NOMBRE', cellEditor: 'cellPrueba', width: 350, editable: (params) => {
        return false;
      }

    },
    {
      headerName: 'Días', field: 'EMP_DIAS', cellEditor: 'cellPrueba', width: 250, editable: (params) => {
        return false;
      }, cellStyle: { textAlign: 'right' },

    },
  ]
  constructor(
    public nomdistricencostosService: NomdistricencostosService,
    private init: NuevoComponentService, private auditoriagral: AuditoriagralService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, private busquedaSer: InvbusquedaService,
    private confIniciales: ConfInicialesService, private permisosService: PermisosService, public usuario: Usuario,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };

    this.defaultDetdistricen = {
      editable: true,
      width: 100,
      objeto: 'detdistricen',
      resizable: true
    };

  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.index = 0;
    this.largo = '-2800';
    this.perdiascal = 0
    this.nomdistricencostosService.encdistricen[this.indicador] = {};
    this.nomdistricencostosService.detdistricen = [];
    this.detnomdistricenSelected = {}

    await this.getPermisos();
    await this.buscarPeriodo();
    await this.getListaTipRol();
    //await this.cargardatos()
  }
  // async cargardatos(){
  //   const data = await this.nomdistricencostosService.getemptipodep('')
  //   for (const iterator of data) {
  //     iterator.PERIODO_CODIGO = this.perCodigo
  //     iterator.DETDISCEN_LINEA = 0
  //     iterator.EMP_DIAS = 0

  //   }
  //   this.nomdistricencostosService.detdistricen = data


  // }
  async manejarSenales(valor) {
    if (valor === 'Nuevo') {
      if (this.permisos !== null) {
        if (this.permisos.PERTODO === 0) {
          if (this.permisos.PERINSERCION === 0) {
            this.messageService.add({
              key: 'nomdistricen',
              severity: 'info',
              summary: 'Información',
              detail: 'El usuario ' + this.usuario.identificacion +
                ', no tiene permiso de inserción. Consulte con el Administrador del Sistema.'
            });
            return;
          }
        }
      }
      const data = await this.nomdistricencostosService.validaperiodo(this.perCodigo);
      if (data !== null) {
        for (const iterator of data) {
          if (iterator.COUNT > 0) {
            this.messageService.add({
              key: 'nomdistricen',
              severity: 'info',
              summary: 'Información',
              detail: 'Ya existe una distribución para este periodo'
            });
            return;
          }
        }
      }
      this.nuevo()
    }
    if (valor === 'Guardar') {
      if (this.permisos !== null) {
        if (this.permisos.PERTODO === 0) {
          if (this.permisos.PERACTUALIZACION === 0) {
            this.messageService.add({
              key: 'nomdistricen',
              severity: 'info',
              summary: 'Información',
              detail: 'El usuario ' + this.usuario.identificacion +
                ', no tiene permiso de actualización. Consulte con el Administrador del Sistema.'
            });
            return;
          }
        }
      }
      this.spin = true;
      this.guardar()
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Buscar') {
      if (this.permisos.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisos.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario ' + this.usuario.identificacion + ' no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Borrar') {
      if (this.permisos.PERTODO === 1) {
        this.borrar();
      } else {
        if (this.permisos.PERELIMACION === 1) {
          this.borrar();
        } else {
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }
    if (valor === 'Excel') {
      if (this.nomdistricencostosService.encdistricen[this.indicador].PERIODO_CODIGO !== this.perCodigo) {
        return;
      }
      this.inputfile.nativeElement.click();
    }
    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  async onBasicUpload(ev) {
    let validacionVacio = true;
    console.log(ev[0]);
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    this.spin = true
    const reader = new FileReader();
    const file = ev[0];
    try {
      reader.onload = async (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

        jsonData = workBook.SheetNames.reduce((initial, name) => {
          console.log(workBook.Sheets[name]);
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          return initial;
        }, {});
        console.log(jsonData.Hoja1);

        for (let data of jsonData.Hoja1) {

          delete data.__EMPTY;
          for (let key in data) { // se revisa los campos del json generado del excel,
            // si uno de esos campos no existe o está vacío no se activará el boton de guardar
            if (data[key] === '') {
              validacionVacio = false;
            }

          }
        }
        this.datosJson = jsonData.Hoja1;
        console.log(this.datosJson)
        this.inputfile.nativeElement.value = ''

        await this.validaexcell();

      }
      reader.readAsBinaryString(file);
    } catch (error) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un error al leer los datos del archivo'
      });
      this.spin = false
      return;
    }


  }
  async validaexcell() {
    try {
      const cedulas = Array.from(new Set(this.datosJson.map(item => String(item.CEDULA))))
      const centros = Array.from(new Set(this.datosJson.map(item => item.CENCODIGO)))
      const dias = Array.from(new Set(this.datosJson.map(item => item.DIAS)))
      const diascero = dias.filter(x => x === 0);

      const diasporcentro = this.datosJson.reduce((acc, item) => {
        acc[item.CEDULA] = (acc[item.CEDULA] || 0) + item.DIAS
        return acc
      }, {})
      const data = await this.nomdistricencostosService.validacedulas(cedulas)
      const data2 = await this.nomdistricencostosService.validacentros(centros)
      if (diascero.length > 0) {
        this.messageService.add({
          key: 'nomdistricen',
          severity: 'error',
          summary: 'Error',
          detail: 'No pueden haber días en cero'
        });
        this.spin = false
        return;
      }
      if (data !== null && data !== undefined) {
        if (data.length > 0) {
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar las siguientes cédulas, por favor revisar principalmente que estén activos' + data.join(", ")
          });
          this.spin = false
          return;
        }
      }
      if (data2 !== null && data !== undefined) {
        if (data2.length > 0) {
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar las siguiente centros de costos, por favor revisar el check en la ficha de los siguientes centros de costos ' + data2.join(", ")
          });
          this.spin = false
          return;
        }
      }
      for (const [cedula, totaldias] of Object.entries(diasporcentro)) {
        if (totaldias > this.perdiascal) {
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'error',
            summary: 'Error',
            detail: 'La cédula ' + cedula + ' superó los 30 días del periodo en curso, por favor revisar'
          });
          this.spin = false
          return;
        }

      }
      await this.insertardatos()
      console.log(cedulas)
    } catch (error) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'ocurrió un error al validar los datos de la importación ' + error
      });
      this.spin = false;
      return;
    }

  }
  async insertardatos() {
    try {
      let reg = isNullOrUndefined(this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO) ? '' : this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO
      const data = await this.nomdistricencostosService.eliminadetalleall(reg)
      for (const iterator of this.datosJson) {
        await this.nomdistricencostosService.insertdetalleExcel(iterator, reg)
        await this.auditoriagral.registrarAuditoria('NOM_TRNDISCENIMP',
          reg + '/' + this.perCodigo + '/' + iterator.CEDULA + '/' + iterator.CENCODIGO + '/' + iterator.DIAS, 'I',
          '', '01', '', '', '', '').toPromise();
      }
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'success',
        summary: 'Información',
        detail: 'El registro se insertó de forma correcta'
      });
      this.spin = false;
      await this.cancelar()
    } catch (error) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'ocurrió un error al insertar los datos importados ' + error
      });
      this.spin = false;
    }

  }
  async borrar() {

    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmdistricencos',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          const data = await this.nomdistricencostosService.validaperiodoA(this.perCodigo);
          let numero = this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO
          const rs = await this.nomdistricencostosService.getdetrodistri(numero)
          if (data !== null) {
            for (const iterator of data) {
              if (iterator.PERIODO_ESTADO !== 'P') {
                this.messageService.add({
                  key: 'nomdistricen',
                  severity: 'info',
                  summary: 'Información',
                  detail: 'El periodo debe estar en proceso'
                });
                return;
              }
            }
          }
          if (rs !== null && rs.length > 0) {
            for (const iterator of rs) {
              if (iterator.NUMERO > 0) {
                this.messageService.add({
                  key: 'nomdistricen',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No se puede eliminar, porque está generada la distribución '
                });
                return
              }
            }
          }
          this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO = ''
          await this.nomdistricencostosService.borrarRegistro(numero)
          await this.auditoriagral.registrarAuditoria('NOM_ENCDISCEN',
            numero + '/' + this.perCodigo, 'E',
            '', '01', '', '', '', '').toPromise();
          await this.cancelar()
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'nomdistricen',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación '
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async busqueda() {
    this.opcion = 'BUSCARREG';
    this.types = [
      { label: 'Código', value: 'ENCDISCEN_CODIGO' },
      { label: 'Periodo', value: 'PERIODO_CODIGO' },


    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'NOM_ENCDISCEN';
    this.where = ' ENCDISCEN_CODIGO is not null order by 1 desc';
    this.busquedaSer.busquedaRegNomEncdistri().subscribe((res: any[]) => {
      this.arregloCons = res;
      this.displayDialogBusquedaFast = true;
    });
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BUSCARREG') {
      this.obtenerdatos(opcion.ENCDISCEN_CODIGO)
    }
    this.displayDialogBusquedaFast = false
  }
  async guardar() {
    if (this.nomdistricencostosService.detdistricen.length === 0) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'El detalle no puede estar vacío'
      });
      this.spin = false
      return;
    }
    for (const iterator of this.nomdistricencostosService.detdistricen) {
      if (isNullOrUndefined(iterator.EMP_CODIGO) || iterator.EMP_CODIGO === '') {
        this.messageService.add({
          key: 'nomdistricen',
          severity: 'error',
          summary: 'Error',
          detail: 'El código no puede estar vacío'
        });
        this.spin = false
        return;
      }
      if (isNullOrUndefined(iterator.EMP_RUCIDE) || iterator.EMP_RUCIDE === '') {
        this.messageService.add({
          key: 'nomdistricen',
          severity: 'error',
          summary: 'Error',
          detail: 'El ruc/ced no puede estar vacío'
        });
        this.spin = false
        return;
      }
      if (isNullOrUndefined(iterator.EMP_NOMBRE) || iterator.EMP_NOMBRE === '') {
        this.messageService.add({
          key: 'nomdistricen',
          severity: 'error',
          summary: 'Error',
          detail: 'El campo empleado no puede estar vacío'
        });
        this.spin = false
        return;
      }
    }
    try {
      let reg = ''
      const data = await this.nomdistricencostosService.insertencabezado(this.nomdistricencostosService.encdistricen[this.indicador])
      for (const iterator of data) {
        reg = iterator.ENCDISCEN_CODIGO
        this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO = reg
        await this.auditoriagral.registrarAuditoria('NOM_ENCDISCEN',
          reg + '/periodo:' + this.perCodigo, 'I',
          '', '01', '', '', '', '').toPromise();

        for (const iterator of this.nomdistricencostosService.detdistricen) {
          iterator.ENCDISCEN_CODIGO = reg
          //await this.nomdistricencostosService.insertdetalle(iterator)
          if (iterator.DETDISCEN_LINEA === 0) {
            await this.auditoriagral.registrarAuditoria('NOM_DETDISCEN',
              reg + '/periodo:' + this.perCodigo +'/empCod:' +iterator.EMP_CODIGO, 'I',
              '', '01', '', '', '', '').toPromise();
          }
        }
        this.messageService.add({
          key: 'nomdistricen',
          severity: 'success',
          summary: 'Éxito',
          detail: 'El registro se realizó con éxito'
        });
        this.spin = false
        await this.cancelar()
        this.habilitarBotonesBarra(false, true, false, false, false, false, false);

      }
    } catch (error) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al guardar el registro ' + error
      });
      this.spin = false
    }
  }
  async cancelar() {
    if (isNullOrUndefined(this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO)
      || this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO === '') {
      this.nomdistricencostosService.encdistricen[this.indicador] = {}
      this.nomdistricencostosService.detdistricen = []

      this.selecttipodep = { DEP_CODIGO: '', DEP_NOMBRE: '' };
      this.habilitarBotonesBarra(false, true, false, false, false, false, false);
      document.getElementById('contorno').style.pointerEvents = 'none';
    } else {
      this.selecttipodep = { DEP_CODIGO: '', DEP_NOMBRE: '' };
      this.obtenerdatos(this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO)
    }

  }
  async obtenerdatos(encdisce) {
    try {
      const data = await this.nomdistricencostosService.getenccendis(encdisce)
      for (const iterator of data) {
        this.nomdistricencostosService.encdistricen[this.indicador] = iterator
        const data2 = await this.nomdistricencostosService.getdetcendis(encdisce)
        const per = await this.nomdistricencostosService.validaperiodoA(this.nomdistricencostosService.encdistricen[this.indicador].PERIODO_CODIGO);
        if (per !== null) {
          let fechaInicio = this.convertDate(per[0].PERIODO_FECINI);
          this.fechasPeriodo = `${fechaInicio}`
          this.perCodigo = per[0].PERIODO_CODIGO;
          this.perdiascal = per[0].PERIODO_DIACALC;
        }

        for (const iterator2 of data2) {
          iterator2.EMP_DIAS = isNullOrUndefined(iterator2.EMP_DIAS) ? 0 : iterator2.EMP_DIAS
          iterator2.ENCDISCEN_CODIGO = encdisce
        }
        this.nomdistricencostosService.detdistricen = data2
        //this.aggrid.refreshaggrid(this.nomdistricencostosService.detdistricen,this.defaultDetdistricen.objeto)
        if (iterator.PERIODO_CODIGO !== this.perCodigo) {
          document.getElementById('contorno').style.pointerEvents = 'none';
        } else {
          document.getElementById('contorno').style.pointerEvents = 'all';
        }
        
      }
      this.habilitarBotonesBarra(false, true, false, false, false, false, false);
    } catch (error) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al cargar los datos ' + error
      });
    }
  }
  async nuevo() {
    this.index = 0
    let i = 0;
    this.selecttipodep = { DEP_CODIGO: '', DEP_NOMBRE: '' };
    this.nomdistricencostosService.encdistricen[this.indicador] = {}
    this.nomdistricencostosService.detdistricen = []
    this.nomdistricencostosService.encdistricen[this.indicador] = {
      PERIODO_CODIGO: this.perCodigo,
      ENCDISCEN_CODIGO: ''
    }

    this.habilitarBotonesBarra(true, false, false, true, true, true, true);
    document.getElementById('contorno').style.pointerEvents = 'all';
    const data = await this.nomdistricencostosService.getemptipodep('', '')
    for (const iterator of data) {
      iterator.PERIODO_CODIGO = this.perCodigo
      iterator.DETDISCEN_LINEA = 0
      iterator.EMP_DIAS = 0

    }
    this.nomdistricencostosService.detdistricen = data
  }
  habilitarBotonesBarra(nuevo, guardar, eliminar, primero, anterior, siguiente, ultimo) {
    this.btnNuevo = nuevo;
    this.btnGuardar = guardar;
    this.btnBorrar = eliminar;
    this.botonPrimero = primero;
    this.botonAnterior = anterior;
    this.botonSiguiente = siguiente;
    this.botonUltimo = ultimo
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisos = data[0];
        } else {
          this.permisos = null;
        }
      } else {
        this.permisos = null;
      }
    } catch (e) {
      this.permisos = null;
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });

    }
  }
  async buscarPeriodo() {
    try {
      const per = await this.nomdistricencostosService.buscarPeriodo()
      //console.log(per);
      if (per !== null) {
        let fechaInicio = this.convertDate(per[0].PERIODO_FECINI);
        this.fechasPeriodo = `${fechaInicio}`
        this.perCodigo = per[0].PERIODO_CODIGO;
        this.perdiascal = per[0].PERIODO_DIACALC;
      }
    } catch (error) {
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al consultar el periodo'
      });
    }

  }
  convertDate(date: string) {
    const fecha = new Date(date);
    let month = '' + (fecha.getMonth() + 1);
    let day = '' + fecha.getDate();
    let year = fecha.getFullYear();
    if (month.length < 2) { month = '0' + month }
    if (day.length < 2) { day = '0' + day }

    return `${month}/${year}`;

  }
  async getListaTipRol() {
    let tipRol = {
      DEP_CODIGO: "",
      DEP_NOMBRE: ""
    }
    try {
      const lista = await this.nomdistricencostosService.FunListaTipRol()
      //for (const iterator of lista) {
      this.cmbTIPROL = [tipRol, ...lista];
      //}
      this.selecttipodep = { DEP_CODIGO: '', DEP_NOMBRE: '' };
    } catch (error) {
      console.log(error)
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al consultar el el tipo de rol'
      });
    }
  }
  async selecTipoRol(dato) {
    //this.cmbDEP_CODIGO = dato.value.DEP_CODIGO;

    let reg = isNullOrUndefined(this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO) ? '' : this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO
    if (this.selecttipodep.DEP_CODIGO !== '') {
      const data = await this.nomdistricencostosService.getemptipodep(this.selecttipodep.DEP_CODIGO, reg)
      for (const iterator of data) {
        iterator.PERIODO_CODIGO = this.perCodigo
        iterator.EMP_DIAS = isNullOrUndefined(iterator.EMP_DIAS) ? 0 : iterator.EMP_DIAS
      }
      this.nomdistricencostosService.detdistricen = data
    } else {
      const data = await this.nomdistricencostosService.getemptipodep(this.selecttipodep.DEP_CODIGO, reg)
      for (const iterator of data) {
        iterator.PERIODO_CODIGO = this.perCodigo
        iterator.EMP_DIAS = isNullOrUndefined(iterator.EMP_DIAS) ? 0 : iterator.EMP_DIAS

      }
      this.nomdistricencostosService.detdistricen = data
    }
  }
  changeTabs() {

  }
  seleccionItem(params) {
    if (params === 'btnDistribCC') {
      if (isNullOrUndefined(this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO) || this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO === '') {
        return
      }
      if (this.nomdistricencostosService.encdistricen[this.indicador].PERIODO_CODIGO !== this.perCodigo) {
        return;
      }
      this.distribuirCostos();
      return;
    }
    if (params.object !== undefined) {
      this.detnomdistricenSelected = params.object;

    }

  }
  distribuirCostos() {
    this.displayDialogDistribucion = true;
  }
  cambio(evento) {

  }
  async salirDialog() {
    this.displayDialogDistribucion = false;
    await this.cancelar()
  }
  cerrarReportes() {
    this.displayDialogReportes = false;
  }
  async elimdistricc() {
    this.closeSidebar()
    try {
      const data = await this.nomdistricencostosService.validaperiodoA(this.perCodigo);
      if (data !== null) {
        for (const iterator of data) {
          if (iterator.PERIODO_ESTADO !== 'P') {
            this.messageService.add({
              key: 'nomdistricen',
              severity: 'info',
              summary: 'Información',
              detail: 'El periodo debe estar en proceso'
            });
            return;
          }
        }
      }
      await this.nomdistricencostosService.eliminanomdistri(this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO)
      await this.auditoriagral.registrarAuditoria('NOM_DETROLDISTRI',
        'REVERSAR_NOMDISTRIBUCOINROL/' + this.nomdistricencostosService.encdistricen[this.indicador].ENCDISCEN_CODIGO + '/PERIODO/' + this.perCodigo, 'E',
        '', '01', '', '', '', '').toPromise();
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'success',
        summary: 'Éxito',
        detail: 'Éxito al eliminar la distribución'
      });
    } catch (error) {
      console.log(error)
      this.messageService.add({
        key: 'nomdistricen',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al eliminar la distribución '
      });
    }



  }
  acciones() {
    this.displayAcciones = !this.displayAcciones;
    const elemento = document.getElementsByClassName('layout-config');
    if (this.displayAcciones === true) {
      for (let i = 1; i <= elemento.length; i++) {
        elemento[i - 1].className += ' layout-config-active';
      }
    } else if (this.displayAcciones === false) {
      for (let i = 1; i <= elemento.length; i++) {
        elemento[i - 1].className = 'layout-config';
      }
    }
  }

  closeSidebar() {
    this.displayAcciones = false;
    const elemento = document.getElementsByClassName('layout-config');
    for (let i = 1; i <= elemento.length; i++) {
      elemento[i - 1].className = 'layout-config';
    }
  }
}
